import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M23.5804 16.9373L38.1511 0H34.6983L22.0466 14.7064L11.9417 0H0.286865L15.5675 22.2387L0.286865 40H3.73985L17.1004 24.4695L27.7719 40H39.4268L23.5796 16.9373H23.5804ZM18.8511 22.4346L17.3028 20.2201L4.98401 2.59936H10.2876L20.229 16.8199L21.7773 19.0344L34.7 37.5189H29.3964L18.8511 22.4354V22.4346Z",
      fill: "black"
    }, null, -1)
  ])))
}
export default { render: render }